import { AppModal } from '@components/form/Modal';
import { Modal } from 'antd';
import { ResumeSubscriptionModalProps } from '../subscription.types';
import { useTranslation } from 'react-i18next';

export const ResumeSubscriptionModal = (props: ResumeSubscriptionModalProps) => {
  const { t } = useTranslation();
  const { open, handleClose, loading, onSubmit } = props;
  return (
    <Modal
      classNames={{ content: '!max-w-[420px]' }}
      centered
      onCancel={handleClose}
      open={open}
      title={
        <AppModal.Header>
          <AppModal.Title>{t('resume_the_subscription')}</AppModal.Title>
        </AppModal.Header>
      }
      footer={
        <AppModal.Footer>
          <AppModal.Button variant="outlined" onClick={handleClose} className="w-full text-text-800! capitalize!">
            {t('cancel')}
          </AppModal.Button>
          <AppModal.Button color="primary" className="w-full capitalize!" loading={loading} onClick={onSubmit}>
            {t('resume_subscription')}
          </AppModal.Button>
        </AppModal.Footer>
      }
    >
      <AppModal.Body>
        <div className="text-text-500 font-medium text-sm mb-2">
          {t('welcome_back_reactivate_your_subscription_and_keep_access_to_all_your_current_features')}
        </div>
      </AppModal.Body>
    </Modal>
  );
};
